// extracted by mini-css-extract-plugin
export default {"container":"placeholder_container__iaXCn","image":"placeholder_image__ggAG-","description":"placeholder_description__9R02n"};